import { render, staticRenderFns } from "./VoucherTemplate.vue?vue&type=template&id=011fc7a0&"
import script from "./VoucherTemplate.vue?vue&type=script&lang=js&"
export * from "./VoucherTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports